import { Analytics } from './analytics';

export class ReviewButtonAnalytics extends Analytics {
    constructor(action: any) {
        super();
        action.WRITE_REVIEW_EVENT.on((data) => {
            this.run(() => {
                const linkAnalyticsData = {
                    server: 'club/pc',
                    fName: this.fName('レビューを書く', data.analyticsData.reviewButtonIndex),
                    club: {
                        server: 'club/pc',
                        prop5: this.fName('レビューを書く', data.analyticsData.reviewButtonIndex),
                    }
                };
                window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
            });
        });
    }

    private fName(fName: string, buttonIndex: string) {
        if (buttonIndex == '' || buttonIndex == null) {
            return `${fName}`;
        } else {
            return `${fName}${buttonIndex}`;
        }
    }
}
